import { render, staticRenderFns } from "./tabAeBooking.vue?vue&type=template&id=7532c4d2&scoped=true&"
import script from "./tabAeBooking.vue?vue&type=script&lang=js&"
export * from "./tabAeBooking.vue?vue&type=script&lang=js&"
import style0 from "./tabAeBooking.vue?vue&type=style&index=0&id=7532c4d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7532c4d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7532c4d2')) {
      api.createRecord('7532c4d2', component.options)
    } else {
      api.reload('7532c4d2', component.options)
    }
    module.hot.accept("./tabAeBooking.vue?vue&type=template&id=7532c4d2&scoped=true&", function () {
      api.rerender('7532c4d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/remoteBooking/tabs/tabAeBooking.vue"
export default component.exports